import { FC } from 'react';
import { Button } from '../../../stories/Button.tsx';

import { IImageData } from '../../../pages/Root/services/api/interfaces.ts';
import Image from '../../../components/Image/Image.tsx';

import './GameMedium.scss';

interface IGameMediumProps {
  title: string;
  buttonText: string;
  imageList: IImageData[]
  onClick?: () => void;
}

const GameMedium: FC<IGameMediumProps> = ({ title, buttonText, imageList, onClick,  }) => {
  return (
    <div className="game-medium" role="group">
      <h2 className="visually-hidden">{title}</h2>
      <div className="game-medium__image-wrapper">
        <Image
          withSkeleton
          alt={title}
          imageList={imageList}
        />
      </div>

      <Button
        className="game-medium__button"
        primary
        textColor="#0727E5"
        backgroundColor="#C8D0FB"
        onClick={onClick}
        label={buttonText}
      ></Button>
    </div>
  );
};

export default GameMedium;
